import type { Track } from '../lib/queries';

/**
 * Track colours are database columns, so they arrive as values rather than classes — the pair is
 * always background plus text, never one without the other, which is why this is a component and
 * not a class string.
 */
export function TrackPill({ track, className = '' }: { track: Track; className?: string }) {
  return (
    <span
      className={`text-chip rounded-full px-2.5 py-1 font-semibold ${className}`}
      style={{ backgroundColor: track.colorBg, color: track.colorText }}
    >
      {track.name}
    </span>
  );
}
